import React, { useState, useEffect } from 'react';
import './PoshmarkIntegrationPage.css';

const PoshmarkIntegrationPage = () => {
  const [installed, setInstalled] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Check if extension is installed
    const checkExtension = () => {
      setChecking(true);
      
      // Try multiple methods to detect extension
      const checkMethods = [
        // Method 1: Check for extension's content script marker
        () => {
          const marker = document.getElementById('poshmark-vinted-extension-detector');
          return marker && marker.getAttribute('data-installed') === 'true';
        },
        
        // Method 2: Try to load extension's icon
        () => {
          const img = new Image();
          img.src = 'chrome-extension://bkbimjadjjgeammeganjombbncbgdlho/icon128.png';
          return new Promise((resolve) => {
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
          });
        },
        
        // Method 3: Check localStorage
        () => {
          return localStorage.getItem('pm_vt_extension') === 'installed';
        }
      ];

      // Try synchronous checks first
      if (checkMethods[0]()) {
        setInstalled(true);
        setChecking(false);
        return;
      }

      // Async check for image loading
      checkMethods[1]().then((isInstalled) => {
        if (isInstalled) {
          setInstalled(true);
          localStorage.setItem('pm_vt_extension', 'installed');
        } else {
          setInstalled(false);
          localStorage.setItem('pm_vt_extension', 'not_installed');
        }
        setChecking(false);
      });

      // Fallback timeout
      setTimeout(() => {
        setChecking(false);
      }, 2000);
    };

    checkExtension();

    // Check again when window gets focus (user returns to tab)
    window.addEventListener('focus', checkExtension);
    
    return () => {
      window.removeEventListener('focus', checkExtension);
    };
  }, []);

  const handleDownload = () => {
    window.open('https://chromewebstore.google.com/detail/poshmark-+-vinted-automat/bkbimjadjjgeammeganjombbncbgdlho?authuser=0&hl=en', '_blank');
    
    // After download, wait and check again
    setTimeout(() => {
      window.location.reload();
    }, 5000);
  };

  const handleOpenPoshmark = () => {
    window.open('https://poshmark.com', '_blank');
  };

  if (checking) {
    return (
      <div className="poshmark-page">
        <div className="poshmark-card">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p className="loading-text">Checking extension status...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="poshmark-page">
      <div className="poshmark-card">
        {/* Header with Poshmark + Vinted logos */}
        <div className="poshmark-header">
          <div className="logo-container">
            <div className="logo-box poshmark-logo">P</div>
            <span className="logo-plus">+</span>
            <div className="logo-box vinted-logo">V</div>
          </div>
          <h1 className="poshmark-title">Poshmark & Vinted</h1>
          <p className="poshmark-subtitle">Automation Extension</p>
        </div>

        {/* Main Content - Changes based on installation status */}
        {installed ? (
          /* INSTALLED STATE */
          <div className="installed-section">
            <div className="success-icon">✓</div>
            <h2 className="installed-title">Extension Active</h2>
            <p className="installed-text">
              Auto listing ready for Poshmark & Vinted
            </p>
            
            <button 
              onClick={handleOpenPoshmark}
              className="open-button"
            >
              Open Poshmark
            </button>

            <p className="extension-note">
              Click the extension icon in your browser to configure settings
            </p>
          </div>
        ) : (
          /* NOT INSTALLED STATE */
          <div className="install-section">
            <div className="install-icon">⚡</div>
            <h2 className="install-title">Install Extension</h2>
            <p className="install-text">
              Auto list on Poshmark & Vinted with one click
            </p>
            
            <button 
              onClick={handleDownload}
              className="download-button"
            >
              Add to Chrome - Free
            </button>

            <div className="feature-list">
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span className="feature-text">Auto Listing</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span className="feature-text">Cross-post to Vinted</span>
              </div>
            </div>
          </div>
        )}

        {/* Footer - Clean, no emojis */}
        <div className="poshmark-footer">
          <p className="footer-text">
            {installed 
              ? 'Extension is active • Click icon to manage'
              : 'Works on both platforms • No credit card required'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PoshmarkIntegrationPage;